import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@env/environment';

import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

const originalConsoleLog = console.log;
console.log = (...args: any[]) => {
  if (!args.some(arg => typeof arg === 'string' && arg.includes('OT.CMP'))) {
    originalConsoleLog(...args);
  }
};

function bootstrap() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    // eslint-disable-next-line no-console
    .catch(err => console.error(err));
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
